// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e57661db","453":"aea47eba","732":"d613de02"}[chunkId] + ".chunk.js";
};